import React from 'react'
import { ControlLabel, FormGroup, FormControl, Row, Col } from 'react-bootstrap'
import LeaguePersonnel from './leaguePersonnel'
import { program_type, extLeague_type , cloneLeague_type} from '../helper'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

import HoopSwitch from '../ToggleSwitch'


function ProgramTab(props) {
  const {
      defaultPlaceholders,
      division,
      notifyFormChange,
      renderAssistantCoaches,
      renderSessions,
      renderSubmitButtons,
    coachOptions,
    start_date,
    end_date,
    registration_start_date,
    registration_end_date,
    handleDateChange,
    league,
    allseasonOptions,
    handleAgeVerify,
    ageVerify,
    requireProof,
    showHint,
    openEnrolhint,
    closeEnrolhint,
    disabled,
    clonedLeague,
    type,
    programTypeOptions,
    mode
  } = props
  const showAdditionalNotes = mode !== 'new'
  const formatDateForInput = (dateValue) => {
    if (!dateValue) {
      return ''
    }
    if (dateValue.format) {
      return dateValue.format('YYYY-MM-DD')
    }
    return new Date(dateValue).toISOString().slice(0, 10)
  }
  const renderProgramTypeOptions = () => {
    if (programTypeOptions && programTypeOptions.length) {
      return [
        <option key="program-type-placeholder" value="" disabled>
          ---
        </option>,
        ...programTypeOptions.map((option) => (
          <option key={option.key} value={option.value}>{option.label}</option>
        ))
      ]
    }
    return program_type
  }

  return (
    <div onBlur={notifyFormChange}>
      <div className="coloured-modal program-modal-tab-pane">
        <h3>Details</h3>
        <Row>
          <Col sm={3}>
            <FormGroup>
              <ControlLabel>Season</ControlLabel>
              <FormControl className="opaque-grey" name="season" componentClass="select" id="season" defaultValue={defaultPlaceholders.season} disabled={disabled}>
                {allseasonOptions}
              </FormControl>
            </FormGroup>
          </Col>
          <Col sm={3}>
            <FormGroup>
              <ControlLabel>Type</ControlLabel>
                <FormControl className="opaque-grey" name="type" id="type" componentClass="select" defaultValue={type ? type : defaultPlaceholders.type}>
                  {defaultPlaceholders.league || league ? extLeague_type : clonedLeague ? cloneLeague_type : renderProgramTypeOptions()}
                </FormControl>
            </FormGroup>
          </Col>
          <Col sm={3}>
            <FormGroup>
              <ControlLabel>Division</ControlLabel>
              <FormControl className="opaque-grey" name="division"  componentClass="select" id="division" defaultValue={defaultPlaceholders.division} disabled={disabled}>
                {division}
              </FormControl>
            </FormGroup>
          </Col>
          <Col sm={3}>
            <FormGroup>
              <ControlLabel>Age Group</ControlLabel>
              <FormControl className="opaque-grey" name="ages" type="text" id="ages" defaultValue={defaultPlaceholders.ages} disabled={disabled}/>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col sm={9}>
            <FormGroup>
              <ControlLabel>Name</ControlLabel>
              <FormControl className="opaque-grey" name="group_name" type="text" id="group_name" defaultValue={defaultPlaceholders.group_name} disabled={disabled}/>
            </FormGroup>
          </Col>
          <Col sm={3}>
            <FormGroup>
              <div className="flex flex-row gap-1">
                <div>Require Documentation upload</div>
                <a className="heading-hint" onClick={() => showHint('requireProof')}>
                  <FontAwesomeIcon icon={faInfoCircle} color='white'/>
                  { 
                    requireProof ?
                    <div className="hint-tip-text" id="payment-hint">
                      <span> "Switch to "yes" if users should upload a proof of age or similar document."</span>
                    </div>
                    : ''
                  }
                </a>
              </div>
              No
              <HoopSwitch 
              checked={ageVerify}
              onChange={(e) => handleAgeVerify(e.target.checked)}
              disabled={disabled}
              />
              Yes
            </FormGroup>
          </Col>
        </Row>
          {/* <Col sm={3}> // do be implemented once there is a check on EF3 of dob max vs. athlete's dob
            <FormGroup>
              <ControlLabel>DOB Max</ControlLabel>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                  <MuiThemeProvider theme={hoopstirTheme}>
                    <DatePicker
                      openTo="year" format="MM/DD/YYYY" label="" clearable disableFuture
                      views={["year", "month", "date"]} 
                      value={DOB_max || defaultPlaceholders.DOB_max}
                      onChange={(date) => handleDateChange(date, 'DOB_max')}
                      id="DOB_max" name="DOB_max"
                      placeholder="" className="DOB"
                    />
                  </MuiThemeProvider>
                </MuiPickersUtilsProvider>
            </FormGroup>
          </Col> */}
        <Row>
          <Col sm={3}>
            <FormGroup>
              <ControlLabel>Start Date</ControlLabel>
              <FormControl
                className="opaque-grey program-native-date"
                type="date"
                id="start_date"
                name="start_date"
                value={formatDateForInput(start_date)}
                onChange={(event) => handleDateChange(event.target.value ? new Date(event.target.value) : null, 'start_date')}
                disabled={disabled}
              />
            </FormGroup>
          </Col>
          <Col sm={3}>
            <FormGroup>
              <ControlLabel>End Date</ControlLabel>
              <FormControl
                className="opaque-grey program-native-date"
                type="date"
                id="end_date"
                name="end_date"
                value={formatDateForInput(end_date)}
                onChange={(event) => handleDateChange(event.target.value ? new Date(event.target.value) : null, 'end_date')}
                disabled={disabled}
              />
            </FormGroup>
          </Col>
          <Col sm={3}>
            <FormGroup>
              <div className="flex flex-row gap-1">
                <div>Open Enrolment</div>
                <a className="heading-hint" onClick={() => showHint('openEnrolhint')}>
                  <FontAwesomeIcon icon={faInfoCircle} color='white'/>
                  {
                    openEnrolhint ?
                    <div className="hint-tip-text" id="payment-hint">
                      <span> The date a program becomes OPEN.  An OPEN program displays on enrolment forms.</span>
                    </div>
                    : ''
                  }
                </a>
              </div>
              <FormControl
                className="opaque-grey program-native-date"
                type="date"
                id="registration_start_date"
                name="registration_start_date"
                value={formatDateForInput(registration_start_date)}
                onChange={(event) => handleDateChange(event.target.value ? new Date(event.target.value) : null, 'registration_start_date')}
                disabled={disabled}
              />
            </FormGroup>
          </Col>
          <Col sm={3}>
            <FormGroup>
              <div className="flex flex-row gap-1">
                <div>Close Enrolment</div>
                <a className="heading-hint" onClick={() => showHint('closeEnrolhint')}>
                  <FontAwesomeIcon icon={faInfoCircle} color='white'/>
                  {
                    closeEnrolhint ?
                    <div className="hint-tip-text" id="payment-hint">
                      <span>The date a program becomes CLOSED.  A closed program is not displayed on enrolment forms.</span>
                    </div>
                    : ''
                  }
                </a>
              </div>
              <FormControl
                className="opaque-grey program-native-date"
                type="date"
                id="registration_end_date"
                name="registration_end_date"
                value={formatDateForInput(registration_end_date)}
                onChange={(event) => handleDateChange(event.target.value ? new Date(event.target.value) : null, 'registration_end_date')}
                disabled={disabled}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <FormGroup>
              <ControlLabel>Details/Description</ControlLabel>
              <FormControl className="opaque-grey" name="program_description" componentClass="textarea" id={"program_description"} defaultValue={defaultPlaceholders.program_description} rows={4} disabled={disabled}/>
            </FormGroup>
          </Col>
          {showAdditionalNotes ? (
            <Col sm={6}>
              <FormGroup>
                <ControlLabel>Additional Notes</ControlLabel>
                <FormControl className="opaque-grey" name="additional_notes" componentClass="textarea" id={"additional_notes"} defaultValue={defaultPlaceholders.additional_notes} rows={4} disabled={disabled}/>
              </FormGroup>
            </Col>
          ) : null}
        </Row>
        {
          league || defaultPlaceholders.league ? 
          <LeaguePersonnel coachOptions={coachOptions} renderAssistantCoaches={renderAssistantCoaches} /> 
          :
          null
        }
        <hr></hr>
        <h3>Sessions</h3>
        {renderSessions()}
        {/*<hr></hr>*/}
        {/*{*/}
        {/*  league || defaultPlaceholders.league ?*/}
        {/*  "" :*/}
        {/*  <Fragment>*/}
        {/*    <h3>Virtual Training Sessionssss</h3>*/}
        {/*    {VTSessions()}*/}
        {/*  </Fragment> */}
        {/*}*/}
        <Row className="btn-flex">
          {renderSubmitButtons()}
        </Row>
      </div>
    </div>
  )
}

export default ProgramTab
